class NumberFormatter {

  /**
   * Formats a number into a currency format.
   * - Adds thousand separators.
   * - Handles null or invalid input gracefully.
   * @param {number | null} value - The input number to format.
   * @returns {string} - The formatted currency string (e.g., "1,234.56").
   */
  static formatCurrency(value) {
    if (value === null || value === undefined || isNaN(value)) {
      return 'N/A';
    }
  
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
      currencyDisplay: "narrowSymbol" // ensures "$" instead of "US$"
    }).format(value || 0);
  }

  /**
   * Formats a number into a currency format.
   * - Divides the input by 100.
   * - Adds thousand separators.
   * - Handles null or invalid input gracefully.
   * @param {number | null} value - The input number to format.
   * @returns {string} - The formatted currency string (e.g., "1,234.56").
   */
  static formatCurrencyCents(value) {
    if (value === null || value === undefined || isNaN(value)) {
      return 'N/A';
    }

    const number = value / 100; // Divide by 100
    return number.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    });
  }
}

export default NumberFormatter;
